import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

const PrivacyPolicy = () => {
  return (
    <div
      className="hhg-hero-container"
      style={{
        flexDirection: "column",
        alignItems: "center",
        padding: "80px 20px",
        marginTop: "60px",
        background: "#ffffff",
      }}
    >
      <h1
        className="hhg-hero-heading"
        style={{
          textAlign: "center",
          marginBottom: "40px",
          fontSize: "42px",
          fontWeight: "700",
          color: "#0a4d68",
          letterSpacing: "1px",
        }}
      >
        
      </h1>

      <div
        className="terms-content"
        style={{
          maxWidth: "4000px",
          background: "#fafafa",
          padding: "40px 50px",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          fontSize: "17px",
          color: "#333",
          lineHeight: "1.8",
          fontFamily: "Kanit, sans-serif",
        }}
      >
        <h3
          style={{
            textAlign: "center",
            color: "#0a4d68",
            marginBottom: "25px",
            fontSize: "24px",
          }}
        >
          PRIVACY POLICY
        </h3>

        {/* ---- A. INTRODUCTION ---- */}
        <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>A. INTRODUCTION</h4>
        <p>
          HHG INDUSTRIES PRIVATE LIMITED(“HHG INDUSTRIES PRIVATE LIMITED”) recognizes the importance of privacy of its users and also of maintaining confidentiality of the information provided by its users as a responsible data controller and data processor.
        </p>
        <p>
          This Privacy Policy provides for the practices for handling and securing user's Personal Data (defined hereunder) by HHG INDUSTRIES PRIVATE LIMITEDand its subsidiaries and affiliates. We'll review this Policy from time to time to make sure it's up-to-date and post the latest version here on this page. When we make significant changes, we'll let you know when you next access our services, or by other communications.
        </p>
        <p>
         This Privacy Policy is applicable to any person in India (‘User’) who accesses or uses the information and content made available by HHG INDUSTRIES PRIVATE LIMITEDthrough its website, mobile site, and mobile app (collectively referred to herein as "Platforms"). For the purpose of this Privacy Policy, wherever the context so requires "you" or "your" shall mean User and the term "we", "us", "our" shall mean HHG INDUSTRIES PRIVATE LIMITED. For the purpose of this Privacy Policy, Website means the website(s), mobile site(s) and mobile app(s).
        </p>
        <p>
         By using or accessing the Platforms, the User hereby agrees with the terms of this Privacy Policy and the contents herein. If you disagree with this Privacy Policy please do not use or access our Platforms. This Privacy Policy does not apply to any website(s), mobile sites and mobile apps of third parties, even if their websites/products are linked to our Website. It is recommended that you review the privacy statements and policies of any such third parties with whom you interact. This Privacy Policy is an integral part of your User Agreement with HHG INDUSTRIES PRIVATE LIMITED.
        </p>
        {/* <p>
          This Privacy Policy is an integral part of your User Agreement with HHG INDUSTRIES PRIVATE LIMITED.
        </p> */}

        {/* ---- B. TYPE OF DATA WE COLLECT ---- */}
        <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>
          B. TYPE OF DATA WE COLLECT AND HOW?
        </h4>

        <h4 style={{ marginTop: "25px" }}>B.1. DATA WE COLLECT:</h4>
        <p>The Data is collected to be able to provide the Services, fulfill our legal obligations, and our obligations towards third parties as per our User Agreement.</p>
        <p>We collect the following Data from you:</p>

        <ul style={{ listStyle: "disc", marginLeft: "30px" }}>
          <li>"Personal Data" of you, which means any data by which you are or can be identified and shall include the information, including but not limited to, about your personal identity such as name, gender, marital status, religion, age, profile picture, your contact details such as your email address, postal addresses, telephone (mobile or otherwise) and/or fax numbers.</li>
          <li>Other Data: We may also collect other information and documents including but not limited to:
<br/>-	User interaction history on our Platforms (e.g., pages viewed, content preferences).
<br/> -	Your usernames, passwords, email addresses and other security-related information used by you in relation to our Services.
<br/> -	Data either created by you or by a third party and which you wish to store on our servers such as image files, documents etc.
<br/> -	User Generated or Provided Content such as comments, photos, videos, recommendations, preferences, reviews, and prompts you enter into AI-powered language models we may make available to you on our Platforms.
<br/> -	Your engagement with us on social media platforms (such as Instagram, Twitter or Facebook) including publicly available information about your social media account.
<br/> -	Data available in public domain or received from any third party including personal or non-personal information from your linked social media channels.
</li>
          <li>Usage Information such as: How you interact with our Platforms and communications, including time you spend on our Platforms, searches performed, and the pages, features or functionality you have accessed, and links you have clicked to be redirected to or from our Platforms.</li>
          <li>Profiling Information: We combine information that we collect, generate, or receive to understand you and your interests better, so that we can personalize our Platforms, services and advertising for you.</li>
        </ul>

        <p>
          HHG INDUSTRIES PRIVATE LIMITED will never share any of the information collected without your prior consent unless such action is required by any law enforcement authority for investigation, by court order or in reference to any legal process.
This Policy doesn't cover the collection or use of your data by the other companies whose products, services, or linked websites we feature on our Platforms ("Third Parties").
        </p>

        <h4 style={{ marginTop: "25px" }}>B.2. HOW WE COLLECT DATA?</h4>
         <p>
         We collect personal data in following ways:
        </p>
        <ul style={{ listStyle: "disc", marginLeft: "30px" }}>
          <li><strong>Data Provided by You:</strong> Data you give to us while registration on the Website/Creating an Account/Signing Up, using the contact us Page for customer support or otherwise communicated to us. If you chose not to provide us with a certain mandatory set of data, we may not be able to provide you the desired services. For Example, If you chose to not provide us your name and contact details, we may not be able to provide you with certain personalized content or services.</li>
          <li><strong>Data Collected Automatically:</strong> We generate or collect some information from your computer or device automatically as you use our Platforms or otherwise interact with us. This includes information like your IP address, cookie identifiers, location, the device and browser you're using, and how you use and interact with our website and other Platforms.</li>
          <li><strong>Data received from third parties:</strong> We are sometimes given information about you from third parties - for example, if you come to our website/Platforms via a promotional partner, or when you log into your HHG INDUSTRIES PRIVATE LIMITEDaccount using our social network login feature. We may also receive information from fraud prevention partners we cooperate with, to prevent misuse of personal data and protect our systems.</li>
        </ul>

        {/* ---- C. HOW DO WE USE PERSONAL DATA ---- */}
        <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>C. HOW DO WE USE PERSONAL DATA?</h4>
        <p>We only use your personal data where:</p>
        <ul style={{ listStyle: "disc", marginLeft: "30px" }}>
          <li>Necessary for us to perform a contract with you for access to our Platforms and Services;</li>
          <li>Necessary to pursue our or others' legitimate interests;</li>
          <li>Necessary to exercise legal rights or comply with legal obligations; or</li>
          <li>You've given us your consent.</li>
        </ul>

<p><strong>Performing a Contract:</strong> We use personal data to deliver our Services or facilitate a contract you've entered - or are entering - into with us. In particular, we use personal data to:</p>
<p>•<strong>Make our Platforms work:</strong> We generate results in response to your search queries, for example providing you with a list of the content or informational resources that best meet your requirements.
•<strong>Send you important communications:</strong> We will send you communications about your account or content subscriptions, your HHG INDUSTRIES PRIVATE LIMITEDaccount, or other essential information.
•<strong>Provide customer services.</strong>
•<strong>Maintain your HHG INDUSTRIES PRIVATE LIMITED account.</strong>
•<strong>Run competitions.</strong>



<p><strong>Performing a Contract:</strong> We use personal data to deliver our Services or facilitate a contract you've entered - or are entering - into with us. In particular, we use personal data to:</p>

• <strong>Make our Platforms work:</strong>We generate results in response to your search queries, for example providing you with a list of the content or informational resources that best meet your requirements.<br/>
• <strong>Send you important communications:</strong>We will send you communications about your account or content subscriptions, your HHG INDUSTRIES PRIVATE LIMITEDaccount, or other essential information.<br/>
• <strong>Provide customer services.</strong><br/>
• <strong>Maintain your HHG INDUSTRIES PRIVATE LIMITED account.</strong><br/>
• <strong>Run competitions.</strong>


<p><strong>Legitimate Interests:</strong> We use personal data as necessary to pursue our legitimate interests, or those of third parties. In particular, we use personal data to:</p>

• <strong>Make Platforms work:</strong> We identify and correct faults with areas of our Platforms.<br/>
• <strong>Perform Analytics and Improve our Platforms:</strong> We evaluate how, when and why people use HHG INDUSTRIES PRIVATE LIMITED Platforms, and use this information to analyse and improve the Platforms and content we offer.<br/>
• <strong>Personalise your HHG INDUSTRIES PRIVATE LIMITED experience:</strong> We show you information or content that we believe is most relevant to you. For example, if you've recently viewed content about a specific topic, we may display a message asking whether you'd like to search for related topics, or include information about similar content in your next email newsletter.<br/>
• <strong>Ensure Security and Prevent Fraud:</strong> We implement security measures on our Platforms and conduct fraud-prevention activities. We use information about your device and the network you are connected to (such as IP address) to identify suspicious activity.<br/>
• <strong>Perform Customer Satisfaction Surveys and Market Research.</strong><br/>
• <strong>Send Alerts and Marketing Communications.</strong><br/>
• <strong>Keep Records and Run our Business:</strong> We use information for internal administrative and reporting purposes, and to calculate any fees due to HHG INDUSTRIES PRIVATE LIMITED by partners or advertisers.


<p><strong>Consent:</strong> You hereby provide us your consent for processing your personal data for the following purposes:</p>

• <strong>Make our Platforms work.</strong><br/>
• <strong>Send you important communications.</strong><br/>
• <strong>Provide customer services.</strong><br/>
• <strong>Maintain your HHG INDUSTRIES PRIVATE LIMITED account.</strong><br/>
• <strong>Run competitions.</strong><br/>
• <strong>Perform Analytics and Improve our Platforms.</strong><br/>
• <strong>Personalize your HHG INDUSTRIES PRIVATE LIMITED experience.</strong><br/>
• <strong>Ensure Security and Prevent Fraud.</strong><br/>
• <strong>Send Alerts and Marketing Communications.</strong><br/>
• <strong>Keep Records and Run our Business.</strong>
</p>

<p>You have the <strong>Right to Withdraw</strong> your consent provided herein or otherwise for processing of your personal data. If you withdraw your consent, you will not benefit from promotions and offers from us.</p>

        {/* ---- D. USE OF PERSONAL DATA FOR ADVERTISEMENT ---- */}
       <h4 style={{ color: "#0a4d68", marginTop: "30px" }}>D. USE OF PERSONAL DATA FOR ADVERTISEMENT</h4>
<p>
  You’ll see adverts when you use our Platforms and might also see adverts about 
  HHG INDUSTRIES PRIVATE LIMITED and selected HHG INDUSTRIES PRIVATE LIMITED partners when you're 
  on other platforms. The personal data used to personalize adverts may include 
  information you’ve provided by creating an account or subscribing to a service via 
  the HHG INDUSTRIES PRIVATE LIMITED Website, or through cookies and similar technologies.
</p>
<p>
  HHG INDUSTRIES PRIVATE LIMITED partners with affiliate networks and marketing service 
  providers such as Facebook ("Third-Party Ad Solutions") to market and advertise 
  our services on third-party websites and applications and to measure the 
  effectiveness of advertising campaigns.
</p>

<h4 style={{ color: "#0a4d68", marginTop: "30px" }}>E. COOKIE POLICY</h4>
<p>
  We use cookies and similar technologies to help deliver and optimise our website, 
  improve your experience, and for advertising purposes depending on your privacy 
  settings. Please see our <Link
                to="/CookiePolicy"
                style={{ color: "#0a4d68", textDecoration: "underline" }}
              >
                Cookie Policy
              </Link>  for more information.
</p>

<h4 style={{ color: "#0a4d68", marginTop: "30px" }}>F. DURATION OF STORAGE OF PERSONAL DATA</h4>
<p>
  We keep personal data only for as long as we need to. This depends on the purposes 
  for which personal data was collected, and whether we have a continuing need or 
  legal obligation to retain personal data for a certain period. If we no longer need 
  to process your personal data, we will delete it or ensure that it no longer 
  identifies you.
</p>

<h4 style={{ color: "#0a4d68", marginTop: "30px" }}>G. SECURITY OF YOUR PERSONAL DATA</h4>
<p>
  Keeping personal data secure is our highest priority. We provide thorough data 
  protection and privacy training, as well as security training to all ZIPLOGYX 
  PRIVATE LIMITED employees. We use a range of technical, organizational, and 
  administrative security measures and best-practice techniques depending on the 
  type of data being processed. Once your information is in our possession, we 
  adhere to strict security guidelines, protecting it against unauthorized access.
</p>

<h4 style={{ color: "#0a4d68", marginTop: "30px" }}>H. YOUR RIGHTS</h4>
<p>
  You have certain data protection rights, including the right to ask us for a copy 
  of your personal data; to correct, complete, update, or delete your personal data; 
  and to nominate another person who shall, in the event of your death or incapacity, 
  exercise these rights in accordance with the Law. You also have the right to 
  redress your grievance with respect to the processing of your personal data and 
  for exercising your rights under the Law.
</p>

<h4 style={{ color: "#0a4d68", marginTop: "30px" }}>I. CHANGES TO THE PRIVACY POLICY</h4>
<p>
  We reserve the right to revise this Privacy Policy from time to time to meet 
  various legal, business, and customer requirements. We will duly notify users as 
  may be necessary.
</p>


     
      </div>
    </div>
  );
};

export default PrivacyPolicy;
